
import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import IntegrationLogo from './IntegrationLogo';
import IntegrationFeaturesList from './IntegrationFeaturesList';
import ConnectedIntegration from './ConnectedIntegration';
import IntegrationForm from './IntegrationForm';
import { UseFormReturn } from 'react-hook-form';

interface IntegrationCardProps {
  integration: {
    slug: string;
    name: string;
    logo: string;
    inputs: {
      name: string;
      label: string;
      placeholder: string;
      description: string;
      type: string;
    }[];
    connectedFields: {
      label: string;
      value: string;
      mask?: boolean;
    }[];
    features: string[];
  };
  isConnected: boolean;
  isTesting: boolean;
  form: UseFormReturn<any>;
  onSaveConfig: (data: any) => void;
  onTestConnection: (slug: string) => void;
  onDisconnect: (slug: string) => void;
}

const IntegrationCard: React.FC<IntegrationCardProps> = ({
  integration,
  isConnected,
  isTesting,
  form,
  onSaveConfig,
  onTestConnection,
  onDisconnect
}) => {
  return (
    <Card>
      <CardHeader className="flex items-center space-x-4">
        <IntegrationLogo logoSrc={integration.logo} name={integration.name} />
        <div>
          <CardTitle>{integration.name} Integration</CardTitle>
          <CardDescription>
            {integration.slug === 'mailchimp'
              ? "Connect your Mailchimp account to sync contacts and send automated marketing emails."
              : "Connect your Marketo account to sync leads and create marketing automation workflows."}
          </CardDescription>
        </div>
      </CardHeader>
      <CardContent>
        {isConnected ? (
          <ConnectedIntegration 
            integration={integration} 
            formValues={form.getValues()} 
            onDisconnect={onDisconnect} 
          />
        ) : (
          <IntegrationForm
            form={form}
            inputs={integration.inputs}
            onSubmit={onSaveConfig}
            onTestConnection={() => onTestConnection(integration.slug)}
            isTesting={isTesting}
            integrationSlug={integration.slug}
          />
        )}
      </CardContent>
      <CardFooter className="bg-gray-50 border-t flex flex-col items-start p-4">
        <h3 className="text-sm font-medium mb-2">{integration.name} Integration Features</h3>
        <IntegrationFeaturesList features={integration.features} />
      </CardFooter>
    </Card>
  );
};

export default IntegrationCard;
